import { MODAL_EDIT, MODAL_EDIT_GOOGLE_AUTH } from './constants/modals';

/**
 * @name getModalKey
 * @description KEY модалки по ID модуля
 * @param id
 * @returns {string}
 */
export const getModalKey = (id) => {
  switch (id) {
  // Google user
  case 9:
    return MODAL_EDIT_GOOGLE_AUTH;
  default:
    return MODAL_EDIT;
  }
}

/**
 *
 * @name getCountsValue
 * @description Валидация полей discount и total_spent
 * Только числа
 * @param newValue
 * @param max
 * @returns {number|string}
 */
export const getCountsValue = (newValue, max = 99999999999999) => {
  if (newValue === '') {
    return '';
  }
  const numberValue = Number(newValue.replace(/\D/g, ''));
  if (numberValue > max) {
    return max;
  }
  return numberValue;
}

/**
 *
 * @name getDefaultLanguageCode
 * @description Дефолтный язык из списка languages
 * @param languages
 * @returns {null}
 */
export const getDefaultLanguageCode = (languages) => {
  let code = null;
  if (languages.length) {
    const defaultLanguage = languages.find((language) => language.is_default);
    if (defaultLanguage) {
      code = defaultLanguage.language_code;
    }
  }
  return code;
}

/**
 *
 * @name getName
 * @description Дефолтное имя level
 * @param name
 * @param defaultLanguageCode
 * @returns {*|null}
 */
export const getName = (name, defaultLanguageCode) => {
  if (name && name[defaultLanguageCode]) {
    return name[defaultLanguageCode];
  }
  return null;
}

/**
 *
 * @name sortLevelsBySpent
 * @description Сортировка levels по total_spent (от меньшего к большему)
 * @param a
 * @param b
 * @returns {number}
 */
export const sortLevelsBySpent = (a, b) => {
  if (a.total_spent < b.total_spent) {
    return -1;
  }
  if (a.total_spent > b.total_spent) {
    return 1;
  }
  return 0;
}

/**
 *
 * @name validateNewLevel
 * @description Проверка перед добавлением нового level
 * @param defaultLanguage
 * @param levels
 * @param editLevel
 * @returns {boolean}
 */
export const validateNewLevel = (defaultLanguage, levels, editLevel) => {
  if (!defaultLanguage) {
    throw new Error('Default language is required');
  }
  if (!levels || !levels.length) {
    throw new Error('Levels must be provided');
  }
  if (!editLevel) {
    throw new Error('Edit level is required');
  }
  /**
   * 1 - Поиск похожего имени
   */
  const levelName = levels.find((level) => !!(level.name[defaultLanguage.language_code] && level.name[defaultLanguage.language_code].toLowerCase() === editLevel.name[defaultLanguage.language_code].toLowerCase().trim()))
  if (levelName) {
    throw new Error('A level with this name already exists. Please enter a different name.');
  }
  /**
   * 2 - Поиск похожего total_spent
   */
  const levelSpent = levels.find((level) => level.total_spent === editLevel.total_spent)
  if (levelSpent) {
    throw new Error('A total user spent with this value already exists. Please enter a different value.');
  }
  /**
   * 3 - Ограничение по символам
   * Не более 100
   */
  if (editLevel.name[defaultLanguage.language_code].length > 100) {
    throw new Error('Maximum number of characters 100');
  }
  return true;
}

/**
 *
 * @name validateEditLevel
 * @description Проверка перед редактированием level
 * @param defaultLanguage
 * @param levels
 * @param edit_level_index
 * @param editLevel
 * @returns {boolean}
 */
export const validateEditLevel = (defaultLanguage, levels, edit_level_index, editLevel) => {
  if (!defaultLanguage) {
    throw new Error('Default language is required');
  }
  if (!levels || !levels.length) {
    throw new Error('Levels must be provided');
  }
  if (!editLevel) {
    throw new Error('Edit level is required');
  }
  if (edit_level_index === undefined || edit_level_index === null) {
    throw new Error('Edit level index is required');
  }
  /**
   * 1 - Поиск похожего имени, кроме текущего
   */
  const levelName = levels.find((level, index) => {
    if (index === edit_level_index) {
      return false;
    }
    if (level.name[defaultLanguage.language_code] && level.name[defaultLanguage.language_code].toLowerCase() === editLevel.name[defaultLanguage.language_code].toLowerCase().trim()) {
      return true;
    }
    return false;
  })
  if (levelName) {
    throw new Error('A level with this name already exists. Please enter a different name.');
  }
  /**
   * 2 - Поиск похожего total_spent
   */
  const levelSpent = levels.find((level, index) => {
    if (index !== edit_level_index && level.total_spent === editLevel.total_spent) {
      return true;
    }
    return false;
  })
  if (levelSpent) {
    throw new Error('A total user spent with this value already exists. Please enter a different value.');
  }

  /**
   * 3 - Проверка изменения spent у default
   */
  const levelSpentDefault = levels.find((level, index) => index === edit_level_index && level.is_default && level.total_spent !== editLevel.total_spent)
  if (levelSpentDefault) {
    throw new Error('You can not change total spent in default level');
  }

  /**
   * 4 - Ограничение по символам
   * Не более 100
   */
  if (editLevel.name[defaultLanguage.language_code].length > 100) {
    throw new Error('Maximum number of characters 100');
  }
  return true;
}
